// components/BlogCard.js
import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { utils } from './api';

const BlogCard = ({ blog }) => {
  const navigate = useNavigate();

  const handleCardClick = () => {
    navigate(`/resources/blogs/${blog.slug}`);
  };

  // Generate department from first few words of title or use default
  const getDepartment = () => {
    // You might want to adjust this logic based on your actual department data
    const words = blog.title.split(' ');
    return words.length > 2 ? `${words[0]} ${words[1]}` : 'Healthcare';
  };

  return (
    <Card onClick={handleCardClick}>
      <CardImage 
        src={blog.featured_image_url} 
        alt={blog.title}

      />
      <CardContent>
       {/*  <Department>{getDepartment()}</Department> */}
        <Title>{blog.title}</Title>
        <MetaInfo>
          <PublishDate>{utils.formatDate(blog.published_at)}</PublishDate>
          {blog.read_time && <ReadTime>{blog.read_time} read</ReadTime>}
        </MetaInfo>
      {/*   {blog.excerpt && <Excerpt>{blog.excerpt}</Excerpt>} */}
        <ReadMore>Read More →</ReadMore>
      </CardContent>
    </Card>
  );
};

// Styled components remain the same as previous implementation
const Card = styled.div`
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
  height: 100%;

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
    
    img {
      transform: scale(1.05);
    }
  }
`;

const CardImage = styled.img`
  width: 100%;
  height: 200px;
  object-fit: cover;
  transition: transform 0.3s ease;
`;

const CardContent = styled.div`
  padding: 24px;
`;

const Department = styled.span`
  display: inline-block;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 12px;
`;

const Title = styled.h3`
  font-size: 1.25rem;
  font-weight: 700;
  color: #2d3748;
  line-height: 1.4;
  margin-bottom: 12px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const MetaInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e2e8f0;
`;

const PublishDate = styled.span`
  color: #718096;
  font-size: 0.875rem;
  font-weight: 500;
`;

const ReadTime = styled.span`
  color: #a0aec0;
  font-size: 0.75rem;
`;

const Excerpt = styled.p`
  color: #4a5568;
  font-size: 0.9rem;
  line-height: 1.6;
  margin-bottom: 16px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const ReadMore = styled.span`
  color: #4299e1;
  font-weight: 600;
  font-size: 0.875rem;
  transition: color 0.2s ease;

  ${Card}:hover & {
    color: #3182ce;
  }
`;

export default BlogCard;